import script from "./ContactNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactNav.vue?vue&type=script&setup=true&lang=js"

import "./ContactNav.vue?vue&type=style&index=0&id=c6beb97c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6beb97c"]])

export default __exports__